import { Box } from '@mui/material';
import { Header } from 'components/home';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import React, { useEffect, useState } from 'react';
import useCifaStore from 'stores/cifa/cifa.store';
import { ROUTES } from 'routes/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import ViewComplianceTerm from './ViewComplianceTerm';

interface ComplianceTermValues {
    termo_escolar_pmaf_elaborado: boolean;
    termo_escolar_pmaf_validado_seaf_mt: boolean;
    termo_escolar_ato_normativo_publicado: boolean;
    termo_escolar_ato_normativo_uuid?: string | null;
    termo_escolar_cmdrs_constituido: boolean;
    termo_escolar_atas_reunioes_uuid?: string | null;
}

const ViewComplianceTermPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { cifa } = useCifaStore();

    // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
    const match = /cifa-(\d{4})/.exec(location.pathname);
    const anoReferencia = match ? Number(match[1]) : 2026;

    const [values, setValues] = useState<ComplianceTermValues>({
        termo_escolar_pmaf_elaborado: false,
        termo_escolar_pmaf_validado_seaf_mt: false,
        termo_escolar_ato_normativo_publicado: false,
        termo_escolar_ato_normativo_uuid: null,
        termo_escolar_cmdrs_constituido: false,
        termo_escolar_atas_reunioes_uuid: null,
    });

    useEffect(() => {
        if (!cifa.uuid) {
            navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
            return;
        }
        setValues({
            termo_escolar_pmaf_elaborado: !!cifa.termo_escolar_pmaf_elaborado,
            termo_escolar_pmaf_validado_seaf_mt: !!cifa.termo_escolar_pmaf_validado_seaf_mt,
            termo_escolar_ato_normativo_publicado: !!cifa.termo_escolar_ato_normativo_publicado,
            termo_escolar_ato_normativo_uuid: cifa.termo_escolar_ato_normativo_uuid ?? null,
            termo_escolar_cmdrs_constituido: !!cifa.termo_escolar_cmdrs_constituido,
            termo_escolar_atas_reunioes_uuid: cifa.termo_escolar_atas_reunioes_uuid ?? null,
        });
    }, [cifa, navigate, anoReferencia, location.pathname]);

    return (
        <MenuProvider>
            <TopNavBar />
            <Header title={`CIFA - Visualização do Cumprimento do Termo - ${anoReferencia}`} showBackButton={true} />
            <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>
                <ViewComplianceTerm values={values} />
            </Box>
        </MenuProvider>
    );
};

export default ViewComplianceTermPage;
